// extracted by mini-css-extract-plugin
export default {"cards_item":"yfDv0","card":"SbO19","card_availability_low":"y7Dg4","card_availability_medium":"sXIvx","card_availability_high":"DUXXQ","cards":"WZxUA","cards_group":"jODNH"};